import React from "react";

interface InputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label?: string;
  extra: string;
  placeholder: string;
  variant: string;
  state?: string;
}

function InputField(props: InputFieldProps) {
  const { label, id, extra, placeholder, variant, state, className, ...rest } = props;

  return (
    <div className={`${extra}`}>
      {label && (
        <label
          htmlFor={id}
          className={`ml-0 mb-2 text-sm text-navy-700 dark:text-white ${
            variant === "auth" ? "font-medium" : "font-bold"
          }`}
        >
          {label}
        </label>
      )}
      <input
        {...rest}
        id={id}
        placeholder={placeholder}
        className={`flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none ${
          rest.disabled === true
            ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
            : state === "error"
            ? "border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
            : state === "success"
            ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
            : "border-gray-200 dark:!border-white/10 dark:text-white"
        } ${className || ""}`}
      />
    </div>
  );
}

export default InputField;
